const showHighlightStorageKey = 'pleditor-composer-highlight';
export function getIsOnValue() {
    return localStorage.getItem(showHighlightStorageKey) === 'true';
}
export function setIsOnValue(newValue) {
    localStorage.setItem(showHighlightStorageKey, JSON.stringify(newValue));
}
